import React, { useState } from "react";
import { Divider } from "@gcs/design-system/react";

import Banner from "../../../assets/images/backgrounds/banner-seguro-loterico-desktop.png";
import BannerMobile from "../../../assets/images/backgrounds/banner-seguro-loterico-mobile.png";
import HeroSection from "../../../components/Habitacional/HeroSection";
import AdvantagesSection from "../Sections/AdvantagesSection/AdvantagesSection";
import CoverageSection from "../../../components/common/CoverageSection/CoverageSection";
import AssistanceServiceSection from "../Sections/AssistanceServiceSection/AssistanceServiceSection";
import HireSection from "../Sections/HireSection/HireSection";
import ActivateInsuranceSection from "../Sections/ActivateInsuranceSection/ActivateInsuranceSection";
import FaqSection from "../Sections/FaqSection/FaqSection";
import DocumentsSection from "../Sections/DocumentsSection/DocumentsSection";
import ContactSectionForm from "../Sections/ContactSectionForm/ContactSectionForm";

import ContractImage from "../../../assets/images/empresarial/contract.png";

import {
  LotteryAdvantageList,
  LotteryCoverageList01,
  LotteryCoverageList02,
  LotteryDocumentList,
  LotteryfaqList,
} from "../Constants/BusinessLottery.constants";

export const BusinessLottery = () => {
  const [isOpenForm, setIsOpenForm] = useState(false);

  return (
    <>
      <HeroSection
        backgroundImageDesktop={Banner}
        backgroundImageMobile={BannerMobile}
        primarySubtitle="Seguro Empresarial"
        mainTitle="Lotérico e CCA"
      />
      <AdvantagesSection advantagesList={LotteryAdvantageList} />
      <CoverageSection
        textsList={[
          {
            id: "1-text",
            title: "Cuidado essencial e ágil para sua lotérica ou CCA",
            description: (
              <>
                Quem tem uma lotérica ou é Correspondente Caixa Aqui (CCA) sabe
                que segurança nunca é demais. Pensando em garantir tranquilidade
                e cuidado para você e sua empresa, oferecemos o Seguro
                Empresarial Lotérico e CCA, que traz agilidade para solucionar
                situações inesperadas. Válido por um ano, podendo ser renovado,
                oferece coberturas fixas e adicionais, adaptando o cuidado às
                necessidades da sua empresa.
              </>
            ),
          },
          {
            id: "2-text",
            title: "Coberturas fixas",
            description: (
              <>
                Com o <strong>Seguro Empresarial Lotérico e CCA</strong>, a
                segurança do seu negócio está garantida em duas situações
                inesperadas. <strong>Confira quais são!</strong>
              </>
            ),
          },
        ]}
        coverageList={LotteryCoverageList01}
      />
      <Divider />
      <CoverageSection
        textsList={[
          {
            id: "1-2-text",
            title: "Coberturas adicionais",
            description: (
              <>
                Com o <strong>Seguro Empresarial Lotérico e CCA</strong>, você
                pode incluir outras coberturas que façam sentido para o seu
                negócio. <strong>Confira quais são!</strong>
              </>
            ),
          },
        ]}
        coverageList={LotteryCoverageList02}
      />
      <AssistanceServiceSection serviceName="Seguro Empresarial Lotérico e CCA" />
      <HireSection
        image={ContractImage}
        altImage="Ilustração de documentos ou papéis sobrepostos, representando arquivos ou relatórios, em fundo azul"
        btnLabel="Preencher formulário"
        onClickBtn={() => setIsOpenForm(true)}
        description={
          <>
            Preencha o formulário clicando no botão abaixo. Entraremos em cotato
            para realizar a cotação do seu seguro
          </>
        }
      />
      <ContactSectionForm isOpen={isOpenForm} onToggle={setIsOpenForm} />
      <ActivateInsuranceSection />
      <FaqSection faqTitle="CCA/Lotérico" faqList={LotteryfaqList} />
      <DocumentsSection
        documentType="Seguro Empresarial"
        documentList={LotteryDocumentList}
      />
    </>
  );
};
